/* eslint-disable jsx-a11y/anchor-is-valid */
import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {SnackbarProvider} from 'notistack'
import {FC, useCallback, useEffect, useMemo, useState} from 'react'
import {FormProvider, set, useForm} from 'react-hook-form'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {InputDate} from '../../../../../../components/UI/Input'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {guestHistorySchema} from '../../../../../../util/validationHoteleria'
import {useBed} from '../../../../hooks/useBed'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {useModules} from '../../../../hooks/useModules'
import {useRooms} from '../../../../hooks/useRooms'
import {
  getListComboHuespedService,
  getListHostingHistoryExcelService,
  getListHostingHistoryService,
} from '../../../../services/booking.service'
import {HistoryFilterModel, HistoryGuestModel} from '../../model'
import {Select} from '../../../../../../components/UI/Select'
import {SelectAsyncWrapper} from '../../../../../../components/UI/Form/Input'

interface SelectOption {
  value: string | number | undefined
  label: string | undefined
}

const TableCheckInList: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    updateTable,
    setUpdateTable,
    clearTable,
    setClearTable,
  } = useKTable()
  const methods = useForm<HistoryFilterModel>({
    resolver: yupResolver(guestHistorySchema),
  })
  const {
    control,
    formState: {errors},
    register,
    setValue,
    handleSubmit,
    setError,
    watch,
    reset,
  } = methods
  const {currentTabItem, setShowModalSearch, isAllowed} = useHoteleria()
  const {selectedOn} = useKTable()
  const {changeSearchValues, searchValues, clearSearchValues} = useKhipu()
  const [formValue, setFormValue] = useState<any>(null)
  const [nombresCompletos, setNombresCompletos] = useState<any>(null)
  const [formValueLoading, setFormValueLoading] = useState<any>(false)
  const [modules, setModules] = useState<SelectOption[]>([])
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSite] = useState<SelectOption[]>([])
  const [camp, setCamp] = useState<SelectOption[]>([])
  const [rooms, setRooms] = useState<SelectOption[]>([])
  const [beds, setBeds] = useState<SelectOption[]>([])
  const [genre, setGenre] = useState<SelectOption[]>([])
  const [guestTypes, setGuestTypes] = useState<SelectOption[]>([])

  const {getModules} = useModules()
  const {getRooms} = useRooms()
  const {getBeds} = useBed()
  const {getCompanies, getClients, getSites, getCamps, getMasterTable} = useCentralServices()

  const campamentoId = watch('CampamentoId')
  const NroDoc = watch('NroDoc')

  const getGenresFn = async () => {
    const data = await getMasterTable('Sexo', false)
    setGenre(data)
  }

  const getGuestTypesFn = async () => {
    const data = await getMasterTable('TipoHuesped', true)
    setGuestTypes(data)
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    setValue('CompaniaId', value)
    setError('CompaniaId', {})
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setClient([])
    setSite([])
    setCamp([])
    getClientsFn(value)
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    setValue('ClienteId', value)
    setError('ClienteId', {})
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setSite([])
    setCamp([])
    getSitesFn(value)
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    setValue('SiteId', value)
    setError('SiteId', {})
    setValue('CampamentoId', '')
    setCamp([])
    setValue('ModuloId', '')
    setValue('HabitacionId', '')
    setValue('CamaId', '')
    setModules([])
    setRooms([])
    setBeds([])
    getCampsFn(value)
  }

  const handleFilterCampamento = (e: any) => {
    let value = e.value
    setValue('CampamentoId', value)
    setError('CampamentoId', {})
    setValue('ModuloId', '')
    setValue('HabitacionId', '')
    setValue('CamaId', '')
    setRooms([])
    setBeds([])
    if (value) {
      getModulesFn(value)
    } else {
      setModules([])
    }
  }

  const handleFilterModule = (e: any) => {
    let value = e.value
    setValue('ModuloId', value)
    setError('ModuloId', {})
    setRooms([])
    setBeds([])
    if (value) {
      getRoomsFn(value)
    }
  }

  const handleFilterRoom = (e: any) => {
    let value = e.value
    setValue('HabitacionId', value)
    setError('HabitacionId', {})
    setValue('CamaId', '')
    setBeds([])
    if (value) {
      getBedsFn(value)
    }
  }

  const handleFilterBed = (e: any) => {
    let value = e.value
    setValue('CamaId', value)
    setError('CamaId', {})
  }

  const columns: Column<HistoryGuestModel>[] = useMemo(
    () => [
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            name='CodigoModulo'
            searcheable
          />
        ),
        accessor: 'Modulo_descripcion',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Habitación'
            name='CodigoHabitacion'
            searcheable
          />
        ),
        accessor: 'Habitacion_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Cama'
            name='CodigoCama'
            searcheable
          />
        ),
        accessor: 'Cama_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Empresa Subcontratista'
            name='EmpresaId'
            searcheable
          />
        ),
        accessor: 'Empresa_descripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro Doc' name='NroDoc' searcheable />
        ),
        accessor: 'NroDoc',
      },

      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nombres' name='NombresHuesped' searcheable />
        ),
        accessor: 'NombresHuesped',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Apellido Paterno'
            name='ApellidoPaternoHuesped'
            searcheable
          />
        ),
        accessor: 'ApellidoPaternoHuesped',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Apellido Materno'
            name='ApellidoMaternoHuesped'
            searcheable
          />
        ),
        accessor: 'ApellidoMaternoHuesped',
      },

      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Genero' name='Genero' selecteable data={genre} />
        ),
        accessor: 'Genero',
      },

      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Cargo' name='Cargo' searcheable />
        ),
        accessor: 'Cargo',
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estatus del Huesped'
            name='EstatusHuesped'
            selecteable
            data={guestTypes}
          />
        ),
        accessor: 'EstatusHuesped',
      },

      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Check in' name='FechaCheckIn' dateable />
        ),
        accessor: 'FechaCheckIn',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Programada Check out'
            name='FechaCheckOut'
            dateable
          />
        ),
        accessor: 'FechaCheckOut',
      },
    ],
    [selectedOn, compani, client, camp, site, genre, guestTypes],
  )

  const getModulesFn = async (campamentoId: string) => {
    const data = await getModules({CampamentoId: campamentoId})
    setModules(data)
  }

  const getCompaniesFn = async () => {
    const data = await getCompanies({isCombo: true}, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      getClientsFn(data[0].value as string)
    }
    setCompany(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({isCombo: true, companiaId: companyId}, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})
      getSitesFn(data[0].value as string)
    }
    setClient(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites({isCombo: true, clienteId: clientId}, 1)
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      getCampsFn(data[0].value as string)
    }
    setSite(data)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps({isCombo: true, siteId: siteId}, 1)
    if (data.length === 1) {
      const campamentoId = data[0].value as string
      setValue('CampamentoId', campamentoId)
      getModulesFn(campamentoId)
    }
    setCamp(data)
  }

  const getRoomsFn = async (moduloId: string) => {
    try {
      const data = await getRooms({
        ModuloId: moduloId,
        CampamentoId: campamentoId,
        isCombo: true,
        isHistorial: true,
      })
      const mappedRooms = data.map((item: any) => ({
        value: item.Id,
        label: item.Codigo,
      }))
      setRooms(mappedRooms)
    } catch (error) {
      setRooms([])
    }
  }

  const getBedsFn = async (habitacionId: string) => {
    try {
      const data = await getBeds({
        HabitacionId: habitacionId,
        isCombo: true,
      })
      const mappedBeds = data.map((item: any) => ({
        value: item.Id,
        label: item.Codigo,
      }))
      setBeds(mappedBeds)
    } catch (error) {
      setBeds([])
    }
  }

  const loadOptionsGuest = useCallback(
    async (inputValue: string) => {
      try {
        if (inputValue.length < 3 || !campamentoId) {
          return []
        }
        const isValidDni = /^\d{8}$/.test(inputValue)
        const request = {
          campamentoId: campamentoId,
          nroDoc: inputValue,
        }
        const response = await getListComboHuespedService(request)
        const data = response.data.data || []
        // Si no hay resultados, mostrar modal para crear huésped
        if (data.length === 0 && isValidDni) {
          showModalPopup(inputValue)
          return []
        }
        const mappedGuest = data?.map((item: any) => ({
          value: item.Id,
          label: `${item.Nombres || ''} ${item.ApellidoPaterno || ''} ${
            item.ApellidoMaterno || ''
          } (${item.NumeroDocumento || ''})`,
          ...item,
        }))
        return mappedGuest || []
      } catch (error) {
        console.error('Error fetching guest options:', error)
        return []
      }
    },
    [campamentoId],
  )

  const showModalPopup = (inputValue: string) => {
    // Swal.fire({
    //   title: 'Crear Huésped',
    //   text: 'Este numero de documento no está registrado. ¿Desea crear un nuevo huésped?',
    //   //showDenyButton: true,
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonText: 'Si, crear',
    //   confirmButtonColor: 'var(--kt-primary)',
    //   cancelButtonText: 'No',
    //   showLoaderOnConfirm: true,
    //   allowOutsideClick: () => !Swal.isLoading(),
    // }).then(async (result) => {
    //   /* Read more about isConfirmed, isDenied below */
    //   if (result.isConfirmed) {
    //     const tipoDoc = '01' // Por defecto DNI
    //     setPendingDocumento({ numero: inputValue, tipo: tipoDoc })
    //     setShowModalCreateGuest(true)
    //     Swal.close()
    //   } else if (result.isDenied) {
    //     //Swal.fire('Changes are not saved', '', 'info')
    //   }
    // })
  }

  const getHistory = async () => {
    setShowModalSearch(false)
    setLoading(true)
    try {
      const obj = {...searchValues, ...formValue}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const {data: response} = await getListHostingHistoryService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        // ...formValue,
        ...obj,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getHistory()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }

      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    getCompaniesFn()
    getGenresFn()
    getGuestTypesFn()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getHistory()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setClient([])
      setSite([])
      setCamp([])
      setModules([])
      setRooms([])
      setBeds([])
      // setData([])
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    // setLoading(false)
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])
  useEffect(() => {
    if (formValueLoading) {
      setFormValueLoading(false)
      getHistory()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValueLoading])

  const handleClear = () => {
    reset()
    setFormValue(null)
    setData([])
    setRooms([])
    setBeds([])
    setClearTable(true)
    setNombresCompletos(null)
    setValue('NroDoc', '')
  }

  const onSubmit = (dataForm: HistoryFilterModel) => {
    setPagination({
      ...pagination,
      currentPage: 1,
      perPage: 10,
      totalResults: 0,
    })
    setFormValue(dataForm)
    setFormValueLoading(true)
  }

  const handleChangeDateIni = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaEstadiaIni', value)
    setError('FechaEstadiaIni', {})
  }

  const handleChangeDateFin = (val: any) => {
    let value = val ? val.target.value : ''
    setValue('FechaEstadiaFin', value)
    setError('FechaEstadiaFin', {})
  }

  const handleGuestChange = async (selectedGuest: any) => {
    const nombreCompleto = `${selectedGuest.Nombres || ''} ${selectedGuest.ApellidoPaterno || ''} ${
      selectedGuest.ApellidoMaterno || ''
    } (${selectedGuest.NumeroDocumento || ''})`.trim()
    setNombresCompletos(nombreCompleto)
    setValue('NroDoc', selectedGuest.NumeroDocumento)
  }

  useEffect(() => {
    getHistory()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const handleExport = async () => {
    try {
      const obj = {...searchValues, ...formValue}
      for (var clave in obj) {
        if (obj.hasOwnProperty(clave)) {
          if (obj[clave] === '') {
            obj[clave] = null
          }
        }
      }
      const response = await getListHostingHistoryExcelService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        // ...formValue,
        ...obj,
      })
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Historial de Hospedaje-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {}
  }
  return (
    <>
      {currentTabItem.fromOtherApp ? (
        <KTCard shadow className='m-5'>
          <>
            <FormProvider {...methods}>
              <form className='m-2'>
                <div className='row'>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Compañía:</label>
                    <Select
                      control={control}
                      name='CompaniaId'
                      data={compani}
                      errors={errors}
                      onChangeValue={handleFilterClient}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Cliente:</label>
                    <Select
                      control={control}
                      name='ClienteId'
                      data={client}
                      errors={errors}
                      onChangeValue={handleFilterSite}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Site:</label>
                    <Select
                      control={control}
                      name='SiteId'
                      data={site}
                      errors={errors}
                      onChangeValue={handleFilterCamp}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Campamento:</label>
                    <Select
                      control={control}
                      name='CampamentoId'
                      data={camp}
                      errors={errors}
                      onChangeValue={handleFilterCampamento}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Módulo:</label>
                    <Select
                      control={control}
                      name='ModuloId'
                      data={modules}
                      errors={errors}
                      onChangeValue={handleFilterModule}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Habitación:</label>
                    <Select
                      control={control}
                      name='HabitacionId'
                      data={rooms}
                      errors={errors}
                      onChangeValue={handleFilterRoom}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label>Cama:</label>
                    <Select
                      control={control}
                      name='CamaId'
                      data={beds}
                      errors={errors}
                      onChangeValue={handleFilterBed}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Fecha Inicio de Estadia</label>
                    <InputDate
                      name='FechaEstadiaIni'
                      register={register}
                      errors={errors}
                      onChange={handleChangeDateIni}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <label className='required'>Fecha Fin de Estadia:</label>
                    <InputDate
                      name='FechaEstadiaFin'
                      register={register}
                      errors={errors}
                      onChange={handleChangeDateFin}
                    />
                  </div>
                </div>
                {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
              </form>
              <ButtonWrapper className={'sdx-white-bg'}>
                <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
                <Button label='Limpiar' onClick={handleClear} />
                <Button label='Exportar' onClick={handleExport} disabled={data.length < 1} />
              </ButtonWrapper>
            </FormProvider>
          </>
          <>
            {loading ? <KTableLoading title='Cargando...' /> : null}
            <KTable data={data} columns={columns as any} clearFilters />
          </>
        </KTCard>
      ) : (
        <KTCard shadow className='m-5'>
          {isAllowed('BUSCAR_ENCABEZADO') && (
            <>
              <FormProvider {...methods}>
                <form className='m-2'>
                  <div className='row'>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Compañía:</label>
                      <Select
                        control={control}
                        name='CompaniaId'
                        data={compani}
                        errors={errors}
                        onChangeValue={handleFilterClient}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Cliente:</label>
                      <Select
                        control={control}
                        name='ClienteId'
                        data={client}
                        errors={errors}
                        onChangeValue={handleFilterSite}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Site:</label>
                      <Select
                        control={control}
                        name='SiteId'
                        data={site}
                        errors={errors}
                        onChangeValue={handleFilterCamp}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Campamento:</label>
                      <Select
                        control={control}
                        name='CampamentoId'
                        data={camp}
                        errors={errors}
                        onChangeValue={handleFilterCampamento}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <SelectAsyncWrapper
                        labelText='Nro Documento de Identidad'
                        name='NroDoc'
                        loadOptions={loadOptionsGuest}
                        disabled={!campamentoId}
                        onChangeValue={handleGuestChange}
                        textPlaceholder='Ingrese número de documento'
                        value={NroDoc ? {value: NroDoc, label: nombresCompletos} : null}
                        required
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Módulo:</label>
                      <Select
                        disabled={!campamentoId}
                        control={control}
                        name='ModuloId'
                        data={modules}
                        errors={errors}
                        onChangeValue={handleFilterModule}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label>Habitación:</label>
                      <Select
                        disabled={!campamentoId}
                        control={control}
                        name='HabitacionId'
                        data={rooms}
                        errors={errors}
                        onChangeValue={handleFilterRoom}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label>Cama:</label>
                      <Select
                        disabled={!campamentoId}
                        control={control}
                        name='CamaId'
                        data={beds}
                        errors={errors}
                        onChangeValue={handleFilterBed}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Fecha Inicio de Estadía</label>
                      <InputDate
                        name='FechaEstadiaIni'
                        register={register}
                        errors={errors}
                        onChange={handleChangeDateIni}
                      />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Fecha Fin de Estadía:</label>
                      <InputDate
                        name='FechaEstadiaFin'
                        register={register}
                        errors={errors}
                        onChange={handleChangeDateFin}
                      />
                    </div>
                  </div>
                  {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
                </form>
                <ButtonWrapper className={'sdx-white-bg'}>
                  <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
                  <Button label='Limpiar' onClick={handleClear} />
                  <Button label='Exportar' onClick={handleExport} disabled={data.length < 1} />
                </ButtonWrapper>
              </FormProvider>
            </>
          )}
          {isAllowed('LISTAR') && (
            <>
              {loading ? <KTableLoading title='Cargando...' /> : null}
              <KTable data={data} columns={columns as any} clearFilters />
            </>
          )}
        </KTCard>
      )}
    </>
  )
}

const TableHistoryGuestWrapper = () => {
  return (
    <KTableProvider>
      <div className=''>
        <TableCheckInList />
      </div>
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableHistoryGuestWrapper}
